'use es6';

import { connect } from 'react-redux';
import VideoControls from '../components/video/VideoControls';
import { setVideoPlaySpeed, toggleAutoPlay } from '../actions/AppActions';
import { bindActionCreators } from 'redux';

function mapStateToProps(state) {
  const {
    app: {
      video: {
        autoPlay,
        playSpeed
      }
    }
  } = state;
  return {
    autoPlay,
    playSpeed
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onSetPlaySpeed: setVideoPlaySpeed,
    onToggleAutoPlay: toggleAutoPlay
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoControls);